import { render, staticRenderFns } from "./GeneralService.vue?vue&type=template&id=910209d6&scoped=true"
import script from "./GeneralService.vue?vue&type=script&lang=js"
export * from "./GeneralService.vue?vue&type=script&lang=js"
import style0 from "./GeneralService.vue?vue&type=style&index=0&id=910209d6&prod&scoped=true&lang=css"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "910209d6",
  null
  
)

export default component.exports